import { apiClient, ApiResponse } from './client'

export interface VideoActivityStatus {
  status: 'not_started' | 'completed'
  completedAt: string | null
}

export interface ProductVideoActivityStatusResponse {
  startVideo: VideoActivityStatus
  endVideo: VideoActivityStatus
}

export const productVideoActivityApi = {
  getStatus: (productId: number, classProductId?: number) => {
    const params = new URLSearchParams({ productId: String(productId) })
    if (classProductId) params.append('classProductId', String(classProductId))
    return apiClient.get<ApiResponse<ProductVideoActivityStatusResponse>>(
      `/b2b/my/product-video-activity/status?${params}`
    )
  },

  complete: (productId: number, position: 'start' | 'end', classProductId?: number) =>
    apiClient.post<ApiResponse<{ message: string }>>('/b2b/my/product-video-activity/complete', {
      productId,
      position,
      classProductId,
    }),
}
